import fetchAuthUser from '../../../../common-services/fetch-auth-user'

export default async function loadUserProfile() {
    const authUser = await fetchAuthUser()
    return authUser
}
